import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=0a678fa0&scoped=true&"
import script from "./BreadCrumb.ts?vue&type=script&lang=ts&"
export * from "./BreadCrumb.ts?vue&type=script&lang=ts&"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=0a678fa0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a678fa0",
  null
  
)

export default component.exports